import { IntPrevService } from "../../services/models/intPrev";
const moduleIntPrev = {
	namespaced: true,
	state: {
		intPrevs: [],
		loading: false,
	},
	getters: {
		getIntPrevs(state) {
			return state.intPrevs;
		},
		getLoading(state) {
			return state.loading;
		}
	},
	mutations: {
		loadIntPrevs(state, intPrevs) {
			state.intPrevs = intPrevs;
		}
	},
	actions: {
		async loadIntPrevs({ commit, state }) {
			state.loading = true;
			let intPrevs = await IntPrevService.getAll();
			commit("loadIntPrevs", intPrevs);
			state.loading = false;
		}
	}
}

export default moduleIntPrev;